const config = {
  ssoUrl: 'https://quality.bigroad.com/partner-sign-in/freight', // UPDATE WHEN AVAILABLE
  clarityId: '9bvazyk0vs',
};

export default config;
